import { CheckOutlined } from '@ant-design/icons';
import { CloseOutlined } from '@ant-design/icons';
import Tag               from '@widesk-ui/components/Tag';
import { TagProps }      from '@widesk-ui/components/Tag';

type BoolTagProps = TagProps & {
	boolValue: boolean,
};

const BoolTag = ({ boolValue, ...props }: BoolTagProps) => (
	<Tag
		color={boolValue ? 'green' : 'red'}
		icon={boolValue ? <CheckOutlined /> : <CloseOutlined />}
		{...props}
	>
		{boolValue ? 'Oui' : 'Non'}
	</Tag>
);

export default BoolTag;